module.exports = __webpack_public_path__ + "img/lineamientos.ab38724c.png";